export enum AccountType {
  CONTA_CORRENTE = 'CONTA_CORRENTE',
  CONTA_POUPANCA = 'CONTA_POUPANCA'
}
